import { createAction } from "@reduxjs/toolkit";
import * as ACTIONTYPES from "../action-types/kitchens";

const KITCHENS_GET_REQUEST_ACTION = createAction(ACTIONTYPES.KITCHENS_GET_REQUEST);
const KITCHENS_GET_SUCCESS_ACTION = createAction<any, string>(ACTIONTYPES.KITCHENS_GET_SUCCESS);
const KITCHENS_GET_ERROR_ACTION = createAction<any, string>(ACTIONTYPES.KITCHENS_GET_ERROR);

export { KITCHENS_GET_REQUEST_ACTION, KITCHENS_GET_SUCCESS_ACTION, KITCHENS_GET_ERROR_ACTION };
